import {
  AlertCircle,
  CheckCircle2,
  Clock,
  PauseCircle,
} from "lucide-react";

export type PaymentStatus = "active" | "paused" | "pending" | "not_set_up";

export function PaymentStatusPill({ status }: { status: PaymentStatus }) {
  switch (status) {
    case "active":
      return (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-500/15 px-2.5 py-0.5 text-xs font-medium text-emerald-600 dark:text-emerald-400">
          <CheckCircle2 className="h-3.5 w-3.5" aria-hidden />
          Active
        </span>
      );
    case "pending":
      return (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-amber-500/15 px-2.5 py-0.5 text-xs font-medium text-amber-600 dark:text-amber-400">
          <Clock className="h-3.5 w-3.5" aria-hidden />
          Verification
        </span>
      );
    case "paused":
      return (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground">
          <PauseCircle className="h-3.5 w-3.5" aria-hidden />
          Paused
        </span>
      );
    case "not_set_up":
      return (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-amber-500/15 px-2.5 py-0.5 text-xs font-medium text-amber-700 dark:text-amber-300">
          <AlertCircle className="h-3.5 w-3.5" aria-hidden />
          Not set up
        </span>
      );
  }
}

export function paymentStatusHint(status: PaymentStatus): string {
  switch (status) {
    case "active":
      return "You are currently accepting payments.";
    case "pending":
      return "Stripe is verifying your account.";
    case "paused":
      return "All rails paused — buyers cannot check out.";
    case "not_set_up":
      return "Connect a payout account to start selling.";
  }
}
